export default __webpack_public_path__ + "static/media/download.14e4f923.svg";